import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { ChargeContactApi } from "../../../../Shared/Constants/api";
import { getContactChargeCreationObject } from "../Data/ContactChargeWrappers";

export const createChargeContactApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ChargeContactApi}`,
      getContactChargeCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
